{
	"mainUL": {
		"title": "Ultralight Flights",
		"nazaj": "Back"
	},
	"nav": {
		"vnos": "Entry",
		"zapisi": "Records"
	},
	"labelsUL": {
		"datum": "Date:",
		"pilot": "Select pilot:",
		"instruktor": "Select instructor:",
		"reg": "Select aircraft registration:",
		"namen": "Select purpose:",
		"naloga": "Select task:",
		"vzlet": "Select takeoff:",
		"nezakljucen": "Incomplete flight?",
		"pristanek": "Select landing:",
		"stPristankov": "Number of landings:",
		"opomba": "Note",
		"niMozno": "Since this is a tow flight, you can only edit the log for glider flights.",
		"stanjeStevca": "Engine odometer reading",
		"v_zraku": "Flight time: ",
		"vnosTrajanja": "Enter flight time?",
		"novIcao": "Enter ICAO code",
		"dodajLetalisce": "Add an airport"
	},
	"buttons": {
		"vnesiZapis": "Add record",
		"brisiIzbiro": "Clear selection",
		"dodajLetalisce": "Add"
	},
	"obvestila": {
		"zapisPrihodnost": "The record has a date set in the future, CORRECT the selected date!",
		"zapisCasPrihodnost": "One or more entries contain a time set in the future, check the times!",
		"zapisCasNapaka": "The entry times are incorrect! Check the times again!",
		"napakaPristanka": "Landing time cannot be before takeoff time!",
		"zapisPobrisan": "Record successfully deleted",
		"zapisDodan": "Record successfully added.",
		"napakaPrazenPristanek": "Input error, landing time cannot be empty",
		"posodobitevUspesna": "Update successful",
		"napakaPosodabljanja": "Error updating data.",
		"napakaBranja": "Error reading data.",
		"napakaIzbrisa": "Error deleting data.",
		"vprasanjeIzbris": "Are you sure you want to delete the record?",
		"napakaVnosa": "Input error, check if all required fields are filled!",
		"letZakljucen": "Flight successfully completed.",
		"letNiZakljucen": "Error completing the flight.",
		"napakaDodajanjaLetalisca": "There was an error entering the airport",
		"letalisceNiNajdeno": "The ICAO airport code was not found in the database"
	}
}